import classNames from "classnames";
import AppBar from "@mui/material/AppBar";

import { TopHeaderConfigType } from "shared/api/superadmin/api";
import { useConfigContext } from "shared/contexts/ConfigContext";
import { getTenantFromHostname } from "shared/utils";

import Typography from "features/components/Typography";
import GlobalSearchAction from "features/ui/GlobalSearch/GlobalSearchAction";

import CommonHeaderActions from "./CommonHeaderActions";
import TenantIcon from "./TenantIcon";

interface Props {
  sidebarExpanded: boolean;
  routeActions?: JSX.Element[];
}

const TopHeader = ({ sidebarExpanded, routeActions }: Props) => {
  const {
    general: { topHeader },
    pages,
  } = useConfigContext();

  const generalTopHeader: Partial<TopHeaderConfigType> = topHeader ?? {};
  const pagesTopHeader: Partial<TopHeaderConfigType> = pages?.topHeader ?? {};

  const topHeaderMerged = { ...pagesTopHeader, ...generalTopHeader };
  const tenant = getTenantFromHostname();

  const title = topHeaderMerged?.title || tenant;

  return (
    <AppBar position="sticky" elevation={0}>
      <div
        className={classNames(
          "flex flex-row items-center px-8 pt-2 pb-2 h-full",
          {
            "border-l border-gray-500": !sidebarExpanded,
          }
        )}
      >
        <div className="flex flex-row gap-5 flex-1 min-w-0 items-center">
          <TenantIcon
            image={topHeaderMerged?.tenantIconImage}
            svg={topHeaderMerged?.tenantIconSvg}
            name={title}
          />
          <Typography variant="body1" className="capitalize text-white">
            {title}
          </Typography>
        </div>
        <div className="flex-1 flex justify-center min-w-0 px-4">
          <GlobalSearchAction />
        </div>
        <CommonHeaderActions routeActions={routeActions} />
      </div>
    </AppBar>
  );
};

export default TopHeader;
